import { create } from 'zustand';
import { Thing, ThingBucketType, ThingConfigType } from '../types/ThingType';

interface ThingStore {
    tabIndex: number;
    setTabIndex: (obj: number) => void;

    showTab: boolean;
    setShowTab: (obj: boolean) => void;

    labelBuckets: ThingBucketType[];
    setLabelBuckets: (obj: ThingBucketType[]) => void;

    labelConfigs: ThingConfigType[];
    setLabelConfigs: (obj: ThingConfigType[]) => void;

    thingObj: Thing;
    setThingObj: (obj: Thing) => void;

    isEdit: boolean;
    setIsEdit: (obj: boolean) => void;

    reset: () => void;
}

const useThingStore = create<ThingStore>((set) => ({
    tabIndex: 0,
    setTabIndex: (obj) => set({ tabIndex: obj }),

    showTab: false,
    setShowTab: (obj) => set({ showTab: obj }),

    labelBuckets: [],
    setLabelBuckets: (obj) => set({ labelBuckets: obj }),

    labelConfigs: [],
    setLabelConfigs: (obj) => set({ labelConfigs: obj }),

    thingObj: {},
    setThingObj: (obj) => set({ thingObj: obj }),

    isEdit: false,
    setIsEdit: (obj) => set({ isEdit: obj }),

    reset: () => set({
        tabIndex: 0,
        showTab: false,
        labelBuckets: [],
        labelConfigs: [],
        thingObj: {},
        isEdit: false,
    })

}));

export default useThingStore;
